import { useEffect, useState } from "react";

import { buscarRelatoriosAgendaCare } from "../api/relatoriosAgendaCare";

export default function useRelatoriosAgendaCare(filtros) {
  const [relatorio, setRelatorio] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ativo = true;

    async function carregarRelatorio() {
      try {
        setLoading(true);
        setError(null);
        const data = await buscarRelatoriosAgendaCare(filtros);

        if (ativo) {
          setRelatorio(data);
        }
      } catch (erro) {
        if (ativo) {
          setError(erro);
          setRelatorio(null);
        }
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    }

    carregarRelatorio();

    return () => {
      ativo = false;
    };
  }, [filtros]);

  return {
    relatorio,
    loading,
    error,
  };
}
